module.exports = __webpack_public_path__ + "img/networkSecurity.34c28a64.png";